import ApplicationController from './application_controller';

// Connects to data-controller="retrospective-report-mask"
//
// 画面共有やスクリーンショットで対象者を特定できる情報を出したくない場面があるため、隠せるようにする。
// 氏名や部署は生成物の文中にも現れるため、対象はサイドバーの欄だけではない。
// 見た目は Tailwind の group-data-[masked=true]: で制御し、ここでは属性とCookieだけを触る。
// 初期表示はサーバーがCookieを読んで属性を出すため、隠す設定でも一瞬見えることはない。
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export default class extends ApplicationController {
  static values = {
    cookieKey: String,
  };

  connect() {
    super.connect();
  }

  toggle() {
    const next = this.element.dataset.masked !== 'true';

    this.element.dataset.masked = String(next);
    document.cookie = `${this.cookieKeyValue}=${next}; path=/; max-age=${ONE_YEAR_SECONDS}; samesite=lax`;
  }
}
